import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.scss'; // for styling
import { Button } from '@mui/material';
import { Home } from '@mui/icons-material';

const Sidebar = () => {
  return (
    <div className='Sidebar__sidebar px-4'>
      <nav className='Sidebar__nav_links'>
        <NavLink
          to='/'
          className={({ isActive }) =>
            isActive ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'
          }
        >
          <Button className='Sidebar__navButton' startIcon={<Home />}>
            Home
          </Button>
        </NavLink>
        <NavLink
          to='/noticeboard'
          className={({ isActive }) =>
            isActive ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'
          }
        >
          <Button className='Sidebar__navButton' startIcon={<Home />}>
            Notice
          </Button>
        </NavLink>
        <NavLink
          to='/fees'
          className={({ isActive }) =>
            isActive ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'
          }
        >
          <Button className='Sidebar__navButton' startIcon={<Home />}>
            Fees
          </Button>
        </NavLink>
        <NavLink
          to='/studybin'
          className={({ isActive }) =>
            isActive ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'
          }
        >
          <Button className='Sidebar__navButton' startIcon={<Home />}>
            Library
          </Button>
        </NavLink>
        <NavLink
          to='/courses'
          className={({ isActive }) =>
            isActive ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'
          }
        >
          <Button className='Sidebar__navButton' startIcon={<Home />}>
            Courses
          </Button>
        </NavLink>
      </nav>
    </div>
  );
};

export default Sidebar;
